<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h1>Booking Report</h1>
        </v-card-title>
        <v-divider></v-divider>
          <v-container fluid grid-list-xl>
            <v-layout wrap align-top>
              <v-flex xs12 d-flex>
                  <async-autocomplete
                    v-model="selectedProjects"
                    :model="models.Projects"
                    multiple
                    return-object
                    name="projects"
                    label="Projects"
                    item-text="name"
                    item-value="id"
                  />
              </v-flex>
            </v-layout>

          </v-container>
          <v-container fluid grid-list-xl>
            <v-layout wrap align-top justify-end>
              <v-btn
                :href="bookingReportPdfUrl"
                target="_blank"
                color="primary"
              >
                Просмотреть отчет в PDF
              </v-btn>
              <v-btn
                :href="bookingReportXlsxUrl"
                target="_blank"
                color="primary"
              >
                Просмотреть отчет в XLSX
              </v-btn>
            </v-layout>
          </v-container>

      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import * as models from '../../orm/models/';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';

import { mapActions } from 'vuex';
import STORE from '../../store/STORE';

const getBookingReportData = STORE.modules.reporting.actions.getBookingReportData;

export default {
  name: 'bookingReport',
  data() {
    return {
      models,
      selectedProjects: null,
      isLoading: false,
      reportData: {},
    };
  },
  computed: {
    projectsQuery() {
      let projects = this.selectedProjects;
      let projects_ids = projects !== null ? projects.map((item) => (item.id)) : [];

      return (projects_ids.length > 0) ? '&projects_ids=' + projects_ids.join(',') : '';
    },
    bookingReportPdfUrl() {
      return `/api/v2/reporting/booking_report?format=pdf${this.projectsQuery}`;
    },
    bookingReportXlsxUrl() {
      return `/api/v2/reporting/booking_report?format=xlsx${this.projectsQuery}`;
    }
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
